import inventoryReducer from 'store/slices/inventorySlice';
import lockedLineItemsReducer from 'store/slices/lockedLineItemsSlice';
import stockManagementReducer from 'store/slices/stockManagementSlice';
import inventoryDashboardReducer from 'store/slices/inventoryDashboardSlice';
import vendorManagementReducer from 'store/slices/vendorManagementSlice';
import manufacturerManagementReducer from 'store/slices/manufacturerManagementSlice';

// Combines the inventory queue slice (reversalQueue) with the inventory-domain slices
// so they all appear under state.inventory.* in Redux DevTools.
const inventoryRootReducer = (state, action) => {
  const {
    lockedLineItems,
    stockManagement,
    inventoryDashboard,
    vendorManagement,
    manufacturerManagement,
    ...queueState
  } = state ?? {};
  const prevQueueState = state !== undefined ? queueState : undefined;

  return {
    ...inventoryReducer(prevQueueState, action),
    lockedLineItems: lockedLineItemsReducer(lockedLineItems, action),
    stockManagement: stockManagementReducer(stockManagement, action),
    inventoryDashboard: inventoryDashboardReducer(inventoryDashboard, action),
    vendorManagement: vendorManagementReducer(vendorManagement, action),
    manufacturerManagement: manufacturerManagementReducer(manufacturerManagement, action),
  };
};

export default inventoryRootReducer;
